import { useState } from "react";
import { toCodeValue } from "./FormCell";

// A code is UPPER_SNAKE of its label almost every time, and it can never be
// changed once the record exists. So the code follows the label as it is typed
// — until someone edits the code themselves, at which point it stops, or their
// edit would be overwritten by the next keystroke in the label.
//
// Emptying the code by hand hands control back, which is the only way to undo
// having taken it.
export const useCodeFromLabel = (
  initialLabel = "",
  initialCode = "",
): {
  label: string;
  code: string;
  setLabel: (next: string) => void;
  setCode: (next: string) => void;
} => {
  const [label, setLabelValue] = useState(initialLabel);
  const [code, setCodeValue] = useState(initialCode);
  // A failed submit sends both values back. If the code still matches what the
  // label would derive, nobody had taken it over, so it keeps following.
  const [isCodeOwned, setIsCodeOwned] = useState(
    initialCode !== "" && initialCode !== toCodeValue(initialLabel),
  );

  return {
    label,
    code,
    setLabel: (next) => {
      setLabelValue(next);

      if (!isCodeOwned) {
        setCodeValue(toCodeValue(next));
      }
    },
    setCode: (next) => {
      const normalised = toCodeValue(next);

      setCodeValue(normalised);
      setIsCodeOwned(normalised !== "");
    },
  };
};
